// Tiny dot strip showing which pipeline layers a run used.
// 6 fixed slots in canonical order so visual scanning is easy.

import { LAYER_META } from "@/lib/layers";
import type { Layer } from "@/lib/types";

const ORDER: Layer[] = ["crm", "tdsx", "dc", "sdm", "apps", "tabnext"];

export function LayerDots({
  layers = [],
  size = "sm",
}: {
  layers?: Layer[];
  size?: "sm" | "lg";
}): JSX.Element {
  const dim = size === "lg" ? 10 : 7;
  return (
    <div style={{ display: "inline-flex", gap: 3, alignItems: "center" }}>
      {ORDER.map((id) => {
        const on = layers.includes(id);
        const meta = LAYER_META[id];
        return (
          <span
            key={id}
            title={`${meta.label} · ${on ? "built" : "skipped"}`}
            style={{
              width: dim,
              height: dim,
              borderRadius: 999,
              background: on ? meta.color : "#e5f2f9",
              border: on ? "none" : "1px solid #d5e5f2",
            }}
          />
        );
      })}
    </div>
  );
}
